import Vue from 'vue';
import Router from 'vue-router';
import paths from './paths';
import store from "@/store";

function route(path, view, name) {
    return {
        name: name || view,
        path: path,
        component: (resolve) => import(
            `@/views/${view}.vue`
            ).then(resolve)
    };
}

function userRoutesList() {
    if (store.state.accessToken) {
        return paths.map((path) => route(path.path, path.view, path.name))
            .concat([{ path: '*', redirect: '/home' },]);
    } else {
        return [
            {
                path: '/login',
                name: 'login',
                component: (resolve) => import(
                    `@/views/Login.vue`
                    ).then(resolve)
            },
            {
                path: '/resetpassword',
                name: 'resetpassword',
                component: (resolve) => import(
                    `@/views/ResetPassword.vue`
                    ).then(resolve)
            },
            {
                path: '/setpassword',
                name: 'setpassword',
                component: (resolve) => import(
                    `@/views/SetNewPassword.vue`
                    ).then(resolve)
            },
            {
                path: '/error',
                name: 'errorpage',
                component: (resolve) => import(
                    `@/views/ErrorPage.vue`
                    ).then(resolve)
            },
            {
                path: '*',
                redirect: '/login',
            },
        ];
    }
}

Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: userRoutesList(),
});

export default router;